import DetailsSidebar from './DetailsSidebar'
import UploadDocumentSidebar from './UploadDocumentSidebar'
import { documentFilterSchema, DocumentFilterType } from './schema'
import { FILTER_DOCUMENT_MANAGEMENT } from 'enums/filters'
import { FilterSidebar, SectionFilter } from 'components/Custom/FilterSidebar'
import { TypeOf } from 'zod'
import { FILTER_DOCUMENT_STATUS_SELECT } from 'enums/selects'

export const documentsSidebarIds = {
  FILTRO: 'documents-filter',
  DETALHES: 'documents-detail',
  UPLOAD_FILE: 'documents-upload-file',
  DOWNLOAD_FILE: 'documents-download-file'
}

interface SidebarConfigProps {
  onSubmit: (data: DocumentFilterType) => void
  defaultFilter: DocumentFilterType
  currentFilter: DocumentFilterType
  handleCallGetListDocuments: (idDocumento?: number) => Promise<void>
}
export const documentsSidebarComponents = ({
  defaultFilter,
  onSubmit,
  currentFilter,
  handleCallGetListDocuments
}: SidebarConfigProps) => {
  return {
    [documentsSidebarIds.FILTRO]: (
      <FilterSidebar
        sections={sections}
        schema={documentFilterSchema}
        defaultFilter={defaultFilter}
        currentFilter={currentFilter}
        onSubmit={(data) => onSubmit(data)}
        filterConfig={FILTER_DOCUMENT_MANAGEMENT}
      />
    ),
    [documentsSidebarIds.DETALHES]: <DetailsSidebar />,
    [documentsSidebarIds.UPLOAD_FILE]: (
      <UploadDocumentSidebar handleCallGetListDocuments={handleCallGetListDocuments} />
    )
  }
}

const sections: SectionFilter<TypeOf<typeof documentFilterSchema>>[] = [
  {
    sectionTitle: 'Dados do consorciado',
    fields: [{ name: 'cd_inscricao_nacional', label: 'CPF ou CNPJ', type: 'document' }]
  },
  {
    sectionTitle: 'Dados do comissionado',
    fields: [{ name: 'cpf_cnpj_comissionado', label: 'CPF ou CNPJ', type: 'document' }]
  },
  {
    sectionTitle: '',
    fields: [
      { name: 'st_status', label: 'Tipo', type: 'select', options: FILTER_DOCUMENT_STATUS_SELECT }
    ]
  },
  {
    sectionTitle: 'Período',
    fields: [
      {
        name: 'dt_venda',
        label: 'Data',
        type: 'date',
        doubleField: {
          nameInicial: 'dt_venda.dt_venda_inicial',
          labelInicial: 'Incial',
          nameFinal: 'dt_venda.dt_venda_final',
          labelFinal: 'Final'
        }
      }
    ]
  },
  {
    sectionTitle: 'Número do contrato',
    fields: [
      {
        name: 'id_documento',
        label: 'Data',
        type: 'doubleNumber',
        doubleField: {
          nameInicial: 'id_documento.id_documento_inicial',
          labelInicial: 'Incial',
          nameFinal: 'id_documento.id_documento_final',
          labelFinal: 'Final'
        }
      }
    ]
  }
]
